/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  useEffect,
  useState,
  useMemo,
  useContext,
  Fragment,
  useRef,
} from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import { BiDetail } from "react-icons/bi";
import { FormDropdown } from "ui/combo-box";
import {
  useGetEmployeeDetails,
  useGetPanicAlertUsers,
  useGetUserByRoles,
} from "services/auth";
import { PATHS } from "routes/paths";
import FormInput from "ui/Input";
import { BreadCrumb } from "ui/bread-crumbs";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { useUser } from "hooks/use-user";
import ResolutionNotes from "components/tickets/resolution-notes";
import sweetAlert from "components/sweet-alert";
import { StatusContext, TOGGLE } from "../constants";
import UserDetails from "../common/user-details";
import {
  disableTaskEditing,
  isCallCenterAgent,
  useGetParentTicketList,
} from "../utils";
import {
  useAddPanicAlertIncidentNotes,
  useDeletePanicAlertAttachment,
  useGetPanicAlertIncidentRequestDetails,
  useGetPanicAlertIncidentTaskDetails,
  usePanicAlertIncidentAssignFieldTeam,
  usePanicAlertIncidentSelfAssign,
  useUpdatePanicAlertTask,
} from "services/panic-alert";
import { useGetImageURL } from "services/common";
import { Download, Trash, Upload } from "lucide-react";
import Logo from "../../../assets/images/logo.png";
import { PDFExport } from "@progress/kendo-react-pdf";
import FormSelect from "ui/select";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { useLookupBusinessUnit } from "services/lookups";
import moment from "moment";
import { getLocalISODateString } from "utils/date-utils";

export default function PanicAlertTaskDetails() {
  const [exportTicketData, setExportTicketData] = useState({});
  const [imagePreview, setImagePreview] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [taskDetails, setTaskDetails] = useState({});
  const pdfExportComponent = useRef(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const params = useParams();
  const { status } = useContext(StatusContext);
  const user = useUser();
  const isCCA = user.Roles.includes("Call Center Agent");
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const isCSMonitoring = user.Roles.includes("CS Monitoring");
  const getTaskDetails = user.Roles.includes("CS Monitoring")
    ? useGetPanicAlertIncidentRequestDetails
    : useGetPanicAlertIncidentTaskDetails;
  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: loadingDetails,
    error: detailsError,
    reset: resetDetails,
  } = getTaskDetails();

  const {
    mutate: getFieldTeam,
    data: fieldTeamList,
    isPending: gettingFieldTeam,
  } = useGetUserByRoles();

  const {
    mutate: addTaskNotes,
    data: addingNotesRes,
    isPending: addingNotes,
    reset: resetAddNotes,
  } = useAddPanicAlertIncidentNotes();

  const {
    mutate: assignFieldTeam,
    data: assignTeamRes,
    isPending: assigningTeam,
  } = usePanicAlertIncidentAssignFieldTeam();

  const {
    mutate: assignSelf,
    data: assignSelfRes,
    isPending: assigningSelf,
  } = usePanicAlertIncidentSelfAssign();

  const {
    mutate: getUserDetails,
    data: userDetailsRes,
    error: userDetailsError,
  } = useGetEmployeeDetails();

  const { data: fieldUsersListRes, isPending: gettingFieldUsers } =
    useGetPanicAlertUsers([
      "Driver",
      "Guard",
      "Team Leader",
      "SLM engineer",
      "Site Inspector",
    ]);

  const { mutate: getBusinessUnits, data: businessUnitRes } =
    useLookupBusinessUnit();

  const { mutate: updateTaskDetails, data: updateTaskRes } =
    useUpdatePanicAlertTask();
  const { mutateAsync: getImageURL } = useGetImageURL();
  const { mutate: deleteAttachment } = useDeletePanicAlertAttachment();

  const getHomeURL = useGetParentTicketList(status);
  const form = useForm({
    defaultValues: { attachments: [] },
  });
  const generalProps = { errors: form.formState.errors, control: form.control };
  useEffect(() => {
    getFieldTeam(["Site Inspector"]);
    getBusinessUnits();
    if (params.requestId) {
      getDetails(params.requestId);
    }
  }, []);
  useEffect(() => {
    if (detailsRes) {
      const _details = detailsRes.data;
      const _ticket = {
        ...detailsRes.data,
        emailTime: _details.emailTime
          ? new Date(moment(_details.emailTime))
          : null,
        timeOfAlarm: _details.timeOfAlarm
          ? new Date(moment(_details.timeOfAlarm))
          : null,
        timeOfContactWithTeam: _details.timeOfContactWithTeam
          ? new Date(moment(_details.timeOfContactWithTeam))
          : null,
        vehicleTeamLeftTime: _details.vehicleTeamLeftTime
          ? new Date(moment(_details.vehicleTeamLeftTime))
          : null,
        updatedRemarks: "",
        attachments: [],
      };
      form.reset({
        ..._ticket,
      });

      setTaskDetails({ ..._ticket });

      if (detailsRes.data.assignedToUserId) {
        getUserDetails(detailsRes.data.assignedToUserId);
      }
      const taskDetails = detailsRes.data;

      const getImages = async () => {
        return Promise.all(
          taskDetails.uploadedFiles.map(async (file) => ({
            ...file,
            filePath: await getImageURL(file.filePath),
          })),
        );
      };
      if (taskDetails?.uploadedFiles?.length > 0) {
        (async () => {
          const images = await getImages();

          setUploadedImages(images);
          // full array with resolved filePath URLs
        })();
      }

      const logsObj = {};
      const checkList = {};
      taskDetails.logs.forEach((elm) => {
        logsObj[elm.operation] = elm;
      });
      taskDetails.checkList.forEach((elm) => {
        if (checkList[elm.category]) {
          const temp = checkList[elm.category];

          checkList[elm.category] = {
            [temp.activity]: temp,
            [elm.activity]: elm,
          };
        } else {
          checkList[elm.category] = elm;
        }
      });

      const vehicleCondition = checkList["Vehicle Condition"];
      const severity = checkList?.Severity;
      let isVehicleRed = "";
      let isVehicleGreen = "";
      let isMajorSeverity = "";
      let isMinorSeverity = "";
      if (vehicleCondition) {
        isVehicleRed =
          vehicleCondition["What is vehicle condition"].response === "Red"
            ? "Yes"
            : "No";

        isVehicleGreen =
          vehicleCondition["What is vehicle condition"].response === "Blue"
            ? "Yes"
            : "No";
      }
      if (severity) {
        isMajorSeverity = severity.response === "Major" ? "Yes" : "No";
        isMinorSeverity = severity.response === "Minor" ? "Yes" : "No";
      }

      const _exportTicketData = {
        checkList: [
          [
            { count: 1, heading: "Date", value: taskDetails.createdDateTime },
            {
              count: 2,
              heading: "Vehicle Number",
              value: taskDetails.assetReferenceNumber,
            },
          ],
          [
            {
              count: 3,
              heading: "Start Time",
              value: logsObj["Service started."]?.operationTime,
            },
            {
              count: 4,
              heading: "End Time",
              value: logsObj["Service ended."]?.operationTime,
            },
          ],
          [
            {
              count: 5,
              heading: "LYNX Case No",
              value: taskDetails.caseNo,
            },
            { count: 6, heading: "IMS ", value: taskDetails.isIncidentReport }, //incident report value
          ],
          [
            {
              count: 7,
              heading: "Cash Volume",
              value: checkList["Cash Volume"]?.response, //checklist
            },
            { count: 8, heading: "Region ", value: taskDetails.region },
          ],
          [
            {
              count: 9,
              heading: "Location Risk Level",
              value: checkList["Risk Level"]?.response, //checklist
            },
            {
              count: 10,
              heading: "Vehicle Condition ", //checklist
              value: taskDetails.state,
              checkList: [
                { heading: "Red", value: isVehicleRed },
                { heading: "Green", value: isVehicleGreen },
              ],
            },
          ],
          [
            {
              count: 11,
              heading: "Type of Incident",
              value: taskDetails.category, //category
            },
            {
              count: 12,
              heading: "Potential Severity", //checklist
              value: taskDetails.state,

              checkList: [
                {
                  heading: "Major",
                  value: isMajorSeverity,
                },
                {
                  heading: "Minor",
                  value: isMinorSeverity,
                },
              ],
            },
          ],
          [
            {
              count: 13,
              heading: "Incident Location", //checklist
              value: checkList?.Location?.response,
              colspan: 3,
            },
          ],
          [
            {
              count: 14,
              heading: "Matter Reported", //checklist
              value: taskDetails.createdDateTime,

              checkList: [
                {
                  heading: "Police",
                  value: "",
                },
                {
                  heading: "PSFRD",
                  value: "",
                },
                {
                  heading: "ASSD",
                  value: "",
                },
                {
                  heading: "Ambulance",
                  value: "",
                },
              ],
            },
          ],
          [
            {
              count: 15,
              heading: "Crew Details",
              value: "",
              onlyHeading: true,
              colSpan: 4,
            },
          ],
          [
            {
              heading: "Driver",
              value: taskDetails.driverName
                ?.replace(/\s*\(.*?\)\s*/g, "")
                .trim(),
            },
            {
              heading: "TG", //employeeid
              value: taskDetails.driverEmployeeId,
            },
          ],
          [
            {
              heading: "CTL",
              value: taskDetails.ctlName?.replace(/\s*\(.*?\)\s*/g, "").trim(),
            },
            {
              heading: "TG",
              value: taskDetails.ctlEmployeeId,
            },
          ],
          [
            {
              heading: "Custodian |", //guard
              value: taskDetails.guardName
                ?.replace(/\s*\(.*?\)\s*/g, "")
                .trim(),
            },
            {
              heading: "TG",
              value: taskDetails.guardEmployeeId,
            },
          ],
          [
            {
              heading: "Custodian ||", //custodian
              value: taskDetails.custodianName
                ?.replace(/\s*\(.*?\)\s*/g, "")
                .trim(),
            },
            {
              heading: "TG",
              value: taskDetails.custodianEmployeeId,
            },
          ],
          [
            {
              count: 16,
              heading: "Detail Description of Accident/Breakdown", //remarks
              value: taskDetails.remarks,
              onlyHeading: true,
            },
            {
              count: 17,
              heading: "CSM Team", //createdBy
              value: taskDetails.createdBy,
            },
          ],
          [
            {
              heading: "",
              value: taskDetails.remarks,
              onlyValue: true,
            },
          ],
          [
            {
              count: 18,
              heading: "Security Outcome", //checklist
              value: checkList?.Outcome?.response,
              onlyHeading: true,
            },
            {
              count: 19,
              heading: "Inspector Name", //assignedTo
              value: taskDetails.assignedTo,
            },
          ],
          [
            {
              heading: "",
              value: checkList?.Outcome?.response || ":",
              onlyValue: true,
            },
          ],
          [
            {
              count: 20,
              heading: "Fleet Assessment Give by", //empty
              value: "",
            },
            {
              count: 21,
              heading: "Replacement Vehicle", //empty
              value: "",
            },
          ],
          [
            {
              count: 22,
              heading: "Police Report", //blank
              value: "",
              checkList: [
                {
                  heading: "Faulty",
                  value: "",
                },
                {
                  heading: "No Faulty",
                  value: "",
                },
              ],
            },
          ],
          [
            {
              count: 23,
              heading: "Technical Assessment", //blank
              value: "",
              onlyHeading: true,
              colSpan: 4,
            },
          ],
          [
            {
              heading: "",
              value: ":",
              onlyValue: true,
            },
          ],
          [
            {
              count: 24,
              heading: "Root Cause", //blank
              value: "",
              onlyHeading: true,
              colSpan: 4,
            },
          ],
          [
            {
              heading: "",
              value: ":",
              onlyValue: true,
            },
          ],
          [
            {
              count: 25,
              heading: "Corrective Action", //blank
              value: "",
              onlyHeading: true,
              colSpan: 4,
            },
          ],
          [
            {
              heading: "",
              value: ":",
              onlyValue: true,
            },
          ],
        ],
      };
      setExportTicketData(_exportTicketData);

      resetDetails();
    }

    if (assignTeamRes || assignSelfRes || updateTaskRes) {
      isCSMAgent ? navigate(PATHS.panicAlertCalls) : navigate(getHomeURL);
    }

    if (addingNotesRes) {
      resetAddNotes();
      form.setValue("notesRemarks", "");
      form.setValue("notesAdditionalRemarks", "");
      getDetails(params.requestId);
    }
  }, [
    detailsError,
    detailsRes,
    assignTeamRes,
    assignSelfRes,
    addingNotesRes,
    updateTaskRes,
  ]);

  const onSelfAssign = () => {
    assignSelf(form.getValues("requestId"));
  };

  const onAssignTeam = () => {
    const data = form.getValues();
    const payload = {
      requestId: data.requestId,
      assignedByUserId: user.UserId,
      assignedToUserId: data.assignedToUserId || "",
      remarks: data.updatedRemarks || "",
    };
    if (taskDetails.assignedToUserId !== data.assignedToUserId) {
      sweetAlert({
        title: "Warning",
        text: "Are you sure you want to update team",
        icon: "icon",
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        onCancel: () => {},
        onConfirm: () => {
          assignFieldTeam(payload);
        },
      });
    } else if (taskDetails.updatedRemarks !== data.updatedRemarks) {
      assignFieldTeam(payload);
    } else {
      sweetAlert({
        title: "Warning",
        text: "Nothing to update",
        icon: "icon",
      });
    }
  };

  const createTicketPayload = () => {
    const data = form.getValues();

    const payload = {
      ticketId: taskDetails.ticketId,
      requestId: data.requestId,
      assignedByUserId: user.UserId,
      assignedToUserId: data.assignedToUserId || "",
      remarks: data.updatedRemarks || "",
      totalConnectTimeWithTeam: data.totalConnectTimeWithTeam,
      violationType: data.violationType || undefined,
      sicknessType: data.sicknessType || undefined,
      incidentLocation: data.incidentLocation || undefined,
      isIncidentReport: data.isIncidentReport === "Yes",
      businessUnitId: data.businessUnitId || undefined,
      isWorkOrder: data.isWorkOrder === "Yes",

      driverUserId: data.driverUserId || undefined,
      guardUserId: data.guardUserId || undefined,
      ctlUserId: data.ctlUserId || undefined,
      custodianUserId: data.custodianUserId || undefined,
      violatorUserId: data.violatorUserId || undefined,
      sickStaffUserId: data.sickStaffUserId || undefined,
      emailTime: data.emailTime
        ? getLocalISODateString(data.emailTime)
        : undefined,
      timeOfAlarm: data.timeOfAlarm
        ? getLocalISODateString(data.timeOfAlarm)
        : undefined,
      timeOfContactWithTeam: data.timeOfContactWithTeam
        ? getLocalISODateString(data.timeOfContactWithTeam)
        : undefined,
      vehicleTeamLeftTime: data.vehicleTeamLeftTime
        ? getLocalISODateString(data.vehicleTeamLeftTime)
        : undefined,

      vehicleIdleTime: data.vehicleIdleTime || undefined,

      // status: "string",

      attachments: data?.attachments || [],
    };
    return payload;
  };
  const onUpdateTask = () => {
    updateTaskDetails(createTicketPayload());
  };
  const onReset = () => {
    form.reset({
      ...taskDetails,
      updatedRemarks: "",
    });
  };

  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      requestId: form.getValues("requestId"),
    };
    addTaskNotes(payload);
  };

  const onCancel = () => {
    isCSMAgent ? navigate(PATHS.panicAlertCalls) : navigate(getHomeURL);
  };

  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTaskEditing(status);
  }, [form.watch("status")]);

  const fieldTeam = useMemo(() => {
    if (fieldTeamList) {
      return fieldTeamList?.data?.map((elm) => ({
        ...elm,
        name: `${elm.employeeId}-${elm.name} (${elm.nationality})`,
      }));
    }

    return [];
  }, [taskDetails, fieldTeamList]);

  const onAssigneeChange = (data) => {
    const employee = fieldTeam?.find((elm) => elm.id === data.id);
    if (employee) {
      getUserDetails(employee.employeeId);
    }
  };

  function EmployeeDetails() {
    if (userDetailsError && userDetailsError.status === 403) {
      return <>User Is Not Authorized TO View Data</>;
    }
    if (!form.watch("assignedToUserId") || !userDetailsRes) {
      return <>Assignee Not Assigned</>;
    }

    return <UserDetails user={userDetailsRes.data} />;
  }
  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  const onUpload = () => {
    fileInputRef.current.click();
  };
  const onFileChange = (e) => {
    handleFileChange(e);
    fileInputRef.current.value = "";
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const attachments = form.getValues("attachments");
      reader.onload = (e) => {
        const base64DataUrl = e.target.result;
        const base64String = base64DataUrl.split(",")[1]; // remove data:image/...;base64,

        const fileObject = {
          fileName: file.name,
          contentType: file.type,
          contents: base64String,
        };

        setImagePreview([...imagePreview, base64DataUrl]);

        form.setValue("attachments", [...attachments, fileObject], {
          shouldDirty: true,
        });
        // For JSON
      };

      reader.readAsDataURL(file); // read file as base64
    }
  };

  return (
    <>
      {loadingDetails ||
      addingNotes ||
      assigningTeam ||
      gettingFieldTeam ||
      gettingFieldUsers ||
      assigningSelf ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          items={[
            { to: getHomeURL, text: `Tickets` },

            {
              to: `${PATHS.panicAlertDetails}/${isCallCenterAgent(user) ? form.watch("ticketId") : form.watch("requestId")}`,
              text: taskDetails.caseNo || "Parent",
            },
            {
              text: `Task Details`,
            },
          ]}
        />
        <div className="flex flex-row justify-end w-full gap-2 items-center">
          <Link to={`${PATHS.panicAlertJobCards}/${form.watch("requestId")}`}>
            {/* <Button>Ticket Details</Button> */}
            <Button
              variant="outline"
              className="border-secondary"
              title="View Job Card"
            >
              <BiDetail
                className="text-secondary cursor-pointer"
                fontSize="20px"
              />
            </Button>
          </Link>
          <>
            <Button
              variant="outline"
              className="border-secondary"
              title="Upload Attachment "
              disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
              onClick={onUpload}
            >
              <Upload
                className="text-secondary cursor-pointer"
                fontSize="20px"
              />
            </Button>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={onFileChange}
            />
          </>
          <Button
            variant="outline"
            className="border-secondary"
            title="Download Ticket"
            onClick={exportPDFWithComponent}
          >
            <Download
              className="text-secondary cursor-pointer"
              fontSize="20px"
            />
          </Button>
          <Button
            variant="secondary"
            disabled={isFormDisabled}
            onClick={
              isCSMonitoring
                ? form.handleSubmit(onAssignTeam)
                : form.handleSubmit(onUpdateTask)
            }
          >
            Update
          </Button>

          <Button
            variant="secondary"
            disabled={isFormDisabled}
            onClick={onSelfAssign}
          >
            Self Assign
          </Button>

          <Button
            variant="secondary"
            disabled={isFormDisabled}
            onClick={onReset}
          >
            Reset
          </Button>

          <Button variant="secondary" onClick={onCancel}>
            Home
          </Button>
        </div>
        {/* <div className="flex flex-row justify-end w-full gap-2"></div> */}
        <Card className="form-card  shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Task Details</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="taskNo"
                    label="Task Number"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="createdDateTime"
                    label="Created At"
                    disabled
                  />

                  <FormInput
                    {...generalProps}
                    name="caseNo"
                    label="Parent"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="status"
                    label="State"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="customer"
                    label="Account"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="region"
                    label="Region"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="registrationNo"
                    label="Asset Id"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="officeId"
                    label="Location Name"
                    disabled
                  />

                  <FormInput
                    {...generalProps}
                    name="activityType"
                    label="Activity Type"
                    disabled
                  />

                  <FormDropdown
                    {...generalProps}
                    label="Primary Assignee"
                    name="assignedToUserId"
                    placeholder="Select Assignee"
                    isRequired
                    rules={
                      isCSMonitoring
                        ? {
                            required: "Please Select Assignee",
                          }
                        : {}
                    }
                    detailsView={<EmployeeDetails />}
                    onChange={onAssigneeChange}
                    disabled={isFormDisabled}
                    data={fieldTeam}
                    text="name"
                    id="id"
                  />

                  <FormInput
                    {...generalProps}
                    name="category"
                    label="Category"
                    disabled
                  />

                  <FormInput
                    {...generalProps}
                    name="subCategory"
                    label="Sub Category"
                    disabled
                  />
                </div>

                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full mt-6">
                          <Label
                            label="Remarks"
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={isFormDisabled}
                                style={
                                  form.formState?.errors?.updatedRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.updatedRemarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.updatedRemarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>

                <Tabs
                  defaultValue="notes"
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="notes">Notes</TabsTrigger>

                    <TabsTrigger value="resolutionNotes">
                      Resolution Notes
                    </TabsTrigger>

                    <TabsTrigger value="vehicleBreakdown">
                      Vehicle Breakdown
                    </TabsTrigger>
                    <TabsTrigger value="attachment">Attachment</TabsTrigger>
                  </TabsList>

                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        <FormField
                          control={form.control}
                          name="notesRemarks"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Work Notes" />

                              <FormControl>
                                <Textarea
                                  {...field}
                                  className="border-secondary"
                                  style={{ marginBottom: "16px" }}
                                />
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormField
                          control={form.control}
                          name="notesAdditionalRemarks"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Additional Comments" />
                              <FormControl>
                                <Textarea
                                  {...field}
                                  className="border-secondary mb-4"
                                  style={{ marginBottom: "16px" }}
                                />
                              </FormControl>
                            </FormItem>
                          )}
                        />

                        <div className="flex flex-row w-full justify-end">
                          <Button
                            variant="secondary"
                            onClick={addNotes}
                            type="button"
                          >
                            Post
                          </Button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className=" px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={`${index}-${elm.operation}`}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>
                  <TabsContent value="resolutionNotes">
                    <ResolutionNotes
                      requestId={taskDetails.requestId}
                      ticket={taskDetails}
                    />
                  </TabsContent>
                  <TabsContent value="vehicleBreakdown">
                    <div className="form-row-d-50">
                      <FormDropdown
                        {...generalProps}
                        label="Driver Name"
                        name="driverUserId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Driver"
                        data={
                          fieldUsersListRes?.data.map((elm) => ({
                            ...elm,
                            name: `${elm.employeeId}-${elm.name}`,
                          })) || []
                        }
                        text="name"
                        id="id"
                      />
                      <FormField
                        control={generalProps.control}
                        name="emailTime"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Email Time" />
                            <FormControl>
                              <div className="form-date-picker">
                                <DateTimePicker
                                  disabled
                                  variant="secondary"
                                  className="px-3 py-2 border border-secondary rounded-md "
                                  value={field.value}
                                  placeholder="Select Date"
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                  }}
                                />
                              </div>
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormDropdown
                        {...generalProps}
                        label="Guard Name"
                        name="guardUserId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Guard"
                        data={
                          fieldUsersListRes?.data.map((elm) => ({
                            ...elm,
                            name: `${elm.employeeId}-${elm.name}`,
                          })) || []
                        }
                        text="name"
                        id="id"
                      />
                      <FormField
                        control={generalProps.control}
                        name="timeOfAlarm"
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Time of Alarm" />
                            <FormControl>
                              <div className="form-date-picker">
                                <DateTimePicker
                                  variant="secondary"
                                  disabled={
                                    isFormDisabled || !isCCA || !isCSMAgent
                                  }
                                  className="px-3 py-2 border border-secondary rounded-md "
                                  value={field.value}
                                  placeholder="Select Date"
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                  }}
                                />
                              </div>
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormDropdown
                        {...generalProps}
                        label="CTL Name"
                        name="ctlUserId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Employee"
                        data={
                          fieldUsersListRes?.data.map((elm) => ({
                            ...elm,
                            name: `${elm.employeeId}-${elm.name}`,
                          })) || []
                        }
                        text="name"
                        id="id"
                      />
                      <FormField
                        control={generalProps.control}
                        name="timeOfContactWithTeam"
                        rules={{ required: "Please Select Value" }}
                        render={({ field }) => (
                          <FormItem>
                            <Label
                              label="Time of contact with team"
                              isRequired
                            />
                            <FormControl>
                              <div className="form-date-picker">
                                <DateTimePicker
                                  variant="secondary"
                                  disabled={
                                    isFormDisabled || (!isCCA && !isCSMAgent)
                                  }
                                  className="px-3 py-2 border border-secondary rounded-md "
                                  value={field.value}
                                  placeholder="Select Date"
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                  }}
                                />
                              </div>
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormDropdown
                        {...generalProps}
                        label="Custodian Name"
                        name="custodianUserId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Employee"
                        data={
                          fieldUsersListRes?.data.map((elm) => ({
                            ...elm,
                            name: `${elm.employeeId}-${elm.name}`,
                          })) || []
                        }
                        text="name"
                        id="id"
                      />
                      <FormInput
                        {...generalProps}
                        label="Total Connect Time With Team"
                        name="totalConnectTimeWithTeam"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        isRequired
                        rules={{
                          required: "Please Select Value",
                          pattern: {
                            value: /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/,
                            message:
                              "Time must be in HH:MM:SS (24-hour) format",
                          },
                        }}
                        hideIcons
                      />
                      <FormDropdown
                        {...generalProps}
                        label="Violator Name"
                        name="violatorUserId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Employee"
                        data={
                          fieldUsersListRes?.data.map((elm) => ({
                            ...elm,
                            name: `${elm.employeeId}-${elm.name}`,
                          })) || []
                        }
                        text="name"
                        id="id"
                      />
                      <FormField
                        control={generalProps.control}
                        name="vehicleTeamLeftTime"
                        disabled
                        render={({ field }) => (
                          <FormItem>
                            <Label label="Vehicle-Team Left Time" />
                            <FormControl>
                              <div className="form-date-picker">
                                <DateTimePicker
                                  variant="secondary"
                                  disabled
                                  className="px-3 py-2 border border-secondary rounded-md "
                                  value={field.value}
                                  placeholder="Select Date"
                                  // onChange={(e) => {
                                  //   field.onChange(e.target.value);
                                  // }}
                                />
                              </div>
                            </FormControl>
                          </FormItem>
                        )}
                      />
                      <FormInput
                        {...generalProps}
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        label="Violation Type"
                        name="violationType"
                      />

                      <FormInput
                        {...generalProps}
                        label="Vehicle Idle Time"
                        name="vehicleIdleTime"
                        disabled
                        hideIcons
                      />

                      <FormDropdown
                        {...generalProps}
                        label="Sick Staff"
                        name="sickStaffUserId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Employee"
                        data={
                          fieldUsersListRes?.data.map((elm) => ({
                            ...elm,
                            name: `${elm.employeeId}-${elm.name}`,
                          })) || []
                        }
                        text="name"
                        id="id"
                      />
                      <FormInput
                        {...generalProps}
                        label="Sickness Type"
                        name="sicknessType"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        hideIcons
                      />
                      <FormInput
                        {...generalProps}
                        label="Location"
                        isRequired
                        rules={{ required: "Please Enter Location" }}
                        name="incidentLocation"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                      />
                      <FormSelect
                        {...generalProps}
                        name="isIncidentReport"
                        label="Incident Report"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Value"
                        data={TOGGLE}
                        id="text"
                        text="text"
                        hideIcons
                      />
                      <FormDropdown
                        {...generalProps}
                        label="Department"
                        name="businessUnitId"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Department"
                        data={businessUnitRes?.data || []}
                        text="name"
                        id="id"
                      />
                      <FormSelect
                        {...generalProps}
                        name="isWorkOrder"
                        label="is Work Order"
                        disabled={isFormDisabled || (!isCCA && !isCSMAgent)}
                        placeholder="Select Value"
                        data={TOGGLE}
                        id="text"
                        text="text"
                        hideIcons
                      />
                    </div>
                  </TabsContent>
                  <TabsContent value="attachment">
                    <div className="form-row-d-50">
                      {uploadedImages?.map((elm, index) => (
                        <div
                          className="border border-solid-secondary relative w-[200px] h-[200px"
                          key={index}
                        >
                          {isCCA || isCSMAgent ? (
                            <Button
                              className="absolute top-1 right-2 z-[1]"
                              variant="secondary"
                              type="button"
                              onClick={() => {
                                deleteAttachment({
                                  incidentId: taskDetails.requestId,
                                  filedId: elm.id,
                                });
                              }}
                            >
                              <Trash />
                            </Button>
                          ) : null}

                          <a
                            href={elm.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              className="object-contain"
                              src={elm.filePath}
                              alt="preview"
                            />
                          </a>
                        </div>
                      ))}
                      {imagePreview?.map((elm, index) => (
                        <div
                          className="border border-solid-secondary relative w-[200px] h-[200px"
                          key={index}
                        >
                          <Button
                            className="absolute top-1 right-2 z-[1]"
                            variant="secondary"
                            type="button"
                            onClick={() => {
                              const attachments = imagePreview;

                              attachments.splice(index, 1);
                              form.setValue("attachments", attachments, {
                                shouldDirty: true,
                              });
                              setImagePreview([...attachments]);
                            }}
                          >
                            <Trash />{" "}
                          </Button>{" "}
                          <a
                            href={elm}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              className="] object-contain"
                              src={elm}
                              alt="preview"
                            />
                          </a>
                        </div>
                      ))}
                    </div>
                  </TabsContent>
                </Tabs>
              </CardContent>
              <div
                style={{ position: "absolute", left: "-100000000px", top: 0 }}
              >
                {" "}
                <PDFExport
                  ref={pdfExportComponent}
                  paperSize="auto"
                  margin={{ top: 40, left: 20, right: 20, bottom: 40 }}
                  fileName={`${taskDetails.caseNo} Checklist`}
                  author="LYNX"
                >
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th width="15%" />
                        <th width="70%" />
                        <th width="15%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            border: "1px solid black",
                            padding: 4,
                          }}
                        >
                          <img
                            src={Logo}
                            alt="log"
                            style={{
                              height: "100%", // h-full
                              objectFit: "contain", // object-contain
                            }}
                          />
                        </td>
                        <td style={{ border: "1px solid black" }}>
                          <h1 style={{ textAlign: "center" }}>
                            Transguard Group
                            <br />
                            ACCIDENT/BREAKDOWN INVESTIGATION FORM
                          </h1>
                        </td>
                        <td style={{ border: "1px solid black" }} />
                      </tr>

                      <tr>
                        <td colSpan={3} style={{ padding: 4 }} />
                      </tr>

                      <tr>
                        <td colSpan={3}>
                          <table style={{ width: "100%" }}>
                            <thead>
                              <tr>
                                <th width="20%" />
                                <th width="30%" />
                                <th width="20%" />
                                <th width="30%" />
                              </tr>
                            </thead>
                            <tbody>
                              {exportTicketData?.checkList?.map(
                                (elm, trIndex) => (
                                  <tr key={trIndex}>
                                    {elm.map((item) => (
                                      <Fragment key={item.heading}>
                                        {!item.onlyValue && (
                                          <td
                                            colSpan={
                                              item.colSpan
                                                ? item.colSpan
                                                : item.onlyHeading
                                                  ? 2
                                                  : 1
                                            }
                                            style={{
                                              border: "1px solid black",
                                              backgroundColor: "#d1d5db", // bg-gray-300
                                              padding: "0.5rem", // p-2
                                            }}
                                          >
                                            {item.count !== undefined
                                              ? `${item.count}: `
                                              : ""}
                                            {item.heading}
                                          </td>
                                        )}

                                        {!item.onlyHeading && (
                                          <td
                                            colSpan={
                                              elm.length === 1
                                                ? item.onlyValue
                                                  ? 4
                                                  : 3
                                                : 1
                                            }
                                            style={
                                              item.checkList
                                                ? {}
                                                : {
                                                    border: "1px solid black",
                                                    padding: "0.5rem", // p-2
                                                  }
                                            }
                                          >
                                            {item.checkList ? (
                                              <table
                                                style={{
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {item.checkList.map(
                                                      (subItem) => (
                                                        <Fragment
                                                          key={`head-${subItem.heading}`}
                                                        >
                                                          <th
                                                            width={`${100 / (item.checkList.length * 2)}%`}
                                                          />
                                                          <th
                                                            width={`${100 / (item.checkList.length * 2)}%`}
                                                          />
                                                        </Fragment>
                                                      ),
                                                    )}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    {item.checkList.map(
                                                      (subItem) => (
                                                        <Fragment
                                                          key={subItem.heading}
                                                        >
                                                          <td
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              backgroundColor:
                                                                "#d1d5db", // bg-gray-300
                                                              padding: "0.5rem",
                                                            }}
                                                          >
                                                            {subItem.heading}
                                                          </td>
                                                          <td
                                                            style={{
                                                              border:
                                                                "1px solid black",
                                                              padding: "0.5rem",
                                                            }}
                                                          >
                                                            {subItem.value}
                                                          </td>
                                                        </Fragment>
                                                      ),
                                                    )}
                                                  </tr>
                                                </tbody>
                                              </table>
                                            ) : (
                                              item.value
                                            )}
                                          </td>
                                        )}
                                      </Fragment>
                                    ))}
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </PDFExport>
              </div>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
